module.exports = __webpack_public_path__ + "static/media/alastairSutton.ec5c731b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/alastairSutton.jpg
// module id = 1244
// module chunks = 1